/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

/* eslint-disable prefer-arrow-callback */
AUI().ready(
	/*
	This function gets loaded when all the HTML, not including the portlets, is
	loaded.
	*/

	() => {}
);

Liferay.Portlet.ready(
	/*
	This function gets loaded after each and every portlet on the page.

	portletId: the current portlet's id
	node: the Alloy Node object of the current portlet
	*/


	(_portletId, _node) => {}
);

Liferay.on(
	'allPortletsReady',

	/*
	This function gets loaded when everything, including the portlets, is on
	the page.
	*/

	() => {

		const loadingAnimation = document.querySelector('.loading-account-selection');
		if(loadingAnimation && window.location.href.indexOf("/account-selection") > -1) {
			loadingAnimation.style.display = "block";
		}

		const observer = new MutationObserver(() => {
			if (document.querySelectorAll('.LPMcontainer').length) {
				const lpmContainer = document.querySelector('.LPMcontainer');
				lpmContainer.setAttribute('aria-hidden', 'true');
			}

			if (document.querySelectorAll('.account-selection-container').length) {
				loadingAnimation.style.display = "none";
			}
		});
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});

		const overrideMagellanFormCloseButton = function() {
			let close_button_override_ele = AUI().one("header#header a.close-button-override");
			if (close_button_override_ele) {
				close_button_override_ele.on('click', function(e) {
					e.preventDefault();
					let dropdown_ele = AUI().one("dropdown-menu.autocomplete-dropdown-menu");
					if (dropdown_ele) {
						dropdown_ele.removeClass("show");
					}
					location.href = close_button_override_ele.attr("href");
				});
			}
		}

		overrideMagellanFormCloseButton();
	}
);
